// Shared helpers for fully clearing client-side Supabase auth state.
// Used by account deletion and the global zombie-session safety net.

/** Clear every localStorage and sessionStorage key Supabase or Kin may have written. */
export const clearSupabaseStorage = () => {
  try {
    if (typeof window === "undefined") return;
    const ls = window.localStorage;
    const toRemove: string[] = [];
    for (let i = 0; i < ls.length; i++) {
      const key = ls.key(i);
      if (!key) continue;
      // Supabase auth state
      if (key.startsWith("sb-") || key.startsWith("supabase.")) {
        toRemove.push(key);
        continue;
      }
      // Kin app state (covers kin-garden-plan, kin_kroger_zip, kin_splash_seen,
      // kin_consent_accepted, etc., and any future kin-/kin_ prefixed keys).
      // Note: neither budget tool (Project Budget Tracker, My Budget) writes to
      // localStorage — both persist through Supabase — so there's no
      // budget-related key to name here; don't add a guessed one back in.
      if (key.startsWith("kin-") || key.startsWith("kin_")) {
        toRemove.push(key);
      }
    }
    toRemove.forEach((k) => ls.removeItem(k));
    window.sessionStorage.clear();
  } catch (e) {
    console.warn("clearSupabaseStorage failed:", e);
  }
};

// Module-level flag so any auth listener can swallow expected post-deletion
// errors (orphaned JWT 401s) during the brief window before redirect.
let deletingFlag = false;

export const setDeleting = (value: boolean) => {
  deletingFlag = value;
};

export const isDeleting = () => deletingFlag;
